import { ca } from '@cian/analytics';

export function useTeaserTracking() {
  const trackShowAdvantages = () => {
    ca('teaser', {
      product: {
        name: 'rent_contract_advantages',
      },
    });
  };

  const trackShowFAQ = () => {
    ca('teaser', {
      product: {
        name: 'rent_contract_answers',
      },
    });
  };

  const trackShowSteps = () => {
    ca('teaser', {
      product: {
        name: 'rent_contract_steps',
      },
    });
  };

  const trackShowStickyButton = () => {
    ca('teaser', {
      product: {
        name: 'rent_contract_landing_end_page',
      },
    });
  };

  return {
    trackShowAdvantages,
    trackShowFAQ,
    trackShowSteps,
    trackShowStickyButton,
  };
}
